export default "__VITE_ASSET__cf21329c__"